// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__yISLg","backdrop":"Menu_backdrop__LkF4g","trigger":"Menu_trigger__fQfTc","list":"Menu_list__oD3cV utils_round__jRf3x","item":"Menu_item__4ItQ5"};